"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cardStatusArray = exports.CardStatusEnum = void 0;
var CardStatusEnum;
(function (CardStatusEnum) {
    CardStatusEnum["UNACTIVATED"] = "UNACTIVATED";
    CardStatusEnum["ACTIVE"] = "ACTIVE";
    CardStatusEnum["SUSPENDED"] = "SUSPENDED";
    CardStatusEnum["TERMINATED"] = "TERMINATED";
    CardStatusEnum["REPORTED_LOST"] = "REPORTED_LOST";
    CardStatusEnum["REPORTED_STOLEN"] = "REPORTED_STOLEN";
})(CardStatusEnum || (exports.CardStatusEnum = CardStatusEnum = {}));
exports.cardStatusArray = Object.values(CardStatusEnum);
